<img *ngIf="isLoading" [ngSrc]="'assets/spinner.gif'" [priority]="true" alt="spinner" class="position-absolute app-spinner" height="60" width="60" />
